import { Button, Card, Collapse, Steps } from 'antd';
import Tag from 'antd/es/tag';
import { SendOutlined } from '@ant-design/icons';
import React, { useCallback, useState } from 'react';
import IHsmHistory from '../../interfaces/hsm';
import { useApi } from '../../hooks/api';
import { notificationDCS } from '../../utils/notificationDcs';

const { Step } = Steps;
const { Panel } = Collapse;

interface IProps {
  hsmHistory: IHsmHistory[];
  formatDate(date: Date | undefined): void;
  reloadHistory(): void;
}

const HsmHistoryDetail: React.FC<IProps> = ({
  hsmHistory,
  formatDate,
  reloadHistory,
}) => {
  const { api } = useApi();
  const [resendingId, setResendingId] = useState<string>();

  const handleResend = useCallback(
    async (id: string) => {
      setResendingId(id);
      try {
        await api.post(`/hsm-histories/${id}/resend`);
        notificationDCS({
          type: 'success',
          message: 'Sucesso',
          description: 'Reenvio solicitado com sucesso',
          secondsDuration: 2,
        });
        reloadHistory();
      } catch (err) {
        notificationDCS({
          type: 'error',
          message: 'Erro',
          description: 'Erro ao reenviar notificação',
          secondsDuration: 2,
        });
      } finally {
        setResendingId(undefined);
      }
    },
    [api, reloadHistory],
  );

  const renderHistoryDescription = useCallback(
    (history: IHsmHistory) => {
      return (
        <div>
          <p>{`Ação: ${history.action}`}</p>
          <p>{`Usuário: ${history.user}`}</p>
          {history.action !== 'HSM_CREATED' && (
            <p>
              Notificação Webhook Cliente:
              {history.webhook_notify === true ? (
                <Tag color="success">Notificado</Tag>
              ) : (
                <Tag color="error">Não Notificado</Tag>
              )}
            </p>
          )}
          {history.webhook_notify === false && (
            <Button
              type="primary"
              shape="round"
              size="small"
              icon={<SendOutlined />}
              loading={resendingId === history.id}
              onClick={() => handleResend(history.id)}
            >
              Reenviar
            </Button>
          )}
          <Collapse className="collapse-dcs" defaultActiveKey={[]}>
            <Panel className="collapse-panel-dcs" header="Detalhes: " key="1">
              <p>{history.request}</p>
            </Panel>
          </Collapse>
          <p>{`Data: ${formatDate(history.history_date)}`}</p>
        </div>
      );
    },
    [formatDate, resendingId, handleResend],
  );

  return (
    <Card className="card-hsm-history">
      <div className="page-header">
        <h2>Histórico</h2>
      </div>
      <Steps progressDot direction="vertical">
        {hsmHistory.map(history => (
          <Step
            key={history.id}
            title={history.status}
            description={renderHistoryDescription(history)}
          />
        ))}
      </Steps>
    </Card>
  );
};

export default HsmHistoryDetail;
